var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 text-center"},[_c('font-awesome-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}],class:'fa-' + _vm.size + 'x',attrs:{"icon":"spinner","spin":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }